import React from "react";
import { MenuItem, Select, FormControl, InputLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
    marginBottom: theme.spacing(2),
    '& .MuiFormLabel-root':{
          color:brandTheme.lightBlack,
    }, "& .MuiOutlinedInput-root": {
          // adius: "14px",borderR
    
          "& fieldset": {
            borderColor: brandTheme.mainColor,
          },
    
          "&:hover fieldset": {
            borderColor: brandTheme.mainColor,
          },
    
          "&.Mui-focused fieldset": {
            borderColor: brandTheme.mainColor,
            borderWidth: "2px",
          },
        },
    
        // "& .MuiFormLabel-root": {
        //   color: brandTheme.lightBlack,
        // },
    
        "& .MuiFormLabel-root.Mui-focused": {
          color: brandTheme.mainColor,
          fontWeight: 600,
        },
        '& .MuiOutlinedInput-notchedOutline':{
            borderColor: brandTheme.mainColor,
        },
    
        "& .MuiFormLabel-root.Mui-disabled": {
          color: brandTheme.lightBlack,
        },
  },
}));

const CustomSelect = ({ label, value, onChange, options, placeholder, style, disabled }) => {
  const classes = useStyles();

  return (
    <FormControl variant="outlined" className={style ? style : classes.formControl}>
      {label && <InputLabel>{label}</InputLabel>}
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        label={label} // This works only inside FormControl with InputLabel
        disabled={disabled}
      >
        {placeholder && <MenuItem value="" disabled>{placeholder}</MenuItem>}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelect;
